import { times } from "lodash";
import React from "react";

import Text from "/component/base/Text";
import { layout } from "/styles";

import { SubtitleText, TutorialImage } from "./GeneralTutorials.styles";

interface Props {
  title: string;
  subtitle: string;
  image?: string;
  imageAlt?: string;
  currentScreenIndex?: number;
  maxScreens?: number;
}

const TutorialScreenBase = ({
  title,
  subtitle,
  image,
  imageAlt,
  currentScreenIndex,
  maxScreens = 0,
}: Props) => {
  return (
    <>
      <div
        css={[
          layout.flexVertical,
          layout.spacedChildrenVertical("condensed"),
          { gap: 0, flex: 1, marginTop: 32 },
        ]}
      >
        <div css={[layout.margin("standard")]}>
          <Text variant="title1" color="objectInverse">
            {title}
          </Text>
        </div>
        <div css={[layout.flexLTR, layout.margin("standard")]}>
          <SubtitleText color="objectInverse">{subtitle}</SubtitleText>
        </div>
        <TutorialImage
          css={[{ visibility: image ? "visible" : "hidden" }]}
          alt={imageAlt}
          src={image}
        />
      </div>
      <div
        css={[
          { bottom: 0, visibility: maxScreens > 0 ? "visible" : "hidden" },
          layout.spacedChildrenHorizontal("base"),
        ]}
      >
        {times(maxScreens).map((idx) => (
          <Text
            key={idx}
            color={idx === currentScreenIndex ? "white" : "brandDotBlue"}
            variant="title1"
          >
            .
          </Text>
        ))}
      </div>
    </>
  );
};

export default TutorialScreenBase;
